const getters = {
	sidebar: (state) => state.sidebar,
	token: (state) => state.token,
	user: (state) => state.user,
	departmentId: (state) => state?.user?.position?.department?.id,
	paymentTypes: (state) => state.paymentTypes,
	timeOptions: () => {
		let hours = [];
		for (let i = 0; i < 24; i++) {
			let quarters = ['00', '15', '30', '45'];
			quarters.forEach((quarter) => {
				let hour = i < 10 ? `0${i}` : `${i}`;
				let option = `${hour}:${quarter}`;
				hours.push({ label: option, value: option });
			});
		}
		return hours;
	},
	countries: (state) => state.countries,
	cities: (state) => state.cities,
	allCities: (state) => state.cities,
	blockModes: (state) => state.blockModes,
	campaignPositions: (state) => state.campaignPositions,
	campaignTypes: (state) => state.campaignTypes,
	campaignRedirectTypes: (state) => state.campaignRedirectTypes,
	filterTypes: (state) => state.filterTypes,
	priceRanges: (state) => state.priceRanges,
	contactTypes: (state) => state.contactTypes,
	selectedRestaurants: (state) => state.selectedRestaurants,
	selectedBusinessId: (state) => state.selectedBusinessId,
	loadingOrderId: (state) => state.loadingOrderId,
	closingReasonsGlobal: (state) => state.closingReasonsGlobal,
	rejectReasonsGlobal: (state) => state.rejectReasonsGlobal,
	posSettings: (state) => state.posSettings,
};

export default getters;
